import { useStreamRemove, useStreamsSaved } from '@entities/stream';

const useStreamRemoveModalAdapter = () => {
  const streamRemove = useStreamRemove();
  const savedStreams = useStreamsSaved();

  const removeStream = async (targetStreamId: number) => {
    const isOk = await streamRemove.request(targetStreamId);
    return isOk;
  };

  const getSavedStreams = async (companyIds: string[]) => {
    const result = await savedStreams.request({ companyIds });
    return result;
  };

  return {
    isStreamRemoveLoading: streamRemove.loading,
    removeStream,
    getSavedStreams,
  };
};

export default useStreamRemoveModalAdapter;
